module.exports = __webpack_public_path__ + "img/step46_install_U_frame.908c845b.png";